import { FormHelperText } from '@mui/material';

import { useReservationFormMachines } from '../ReservationFormMachinesContext';
import { useFieldActorSnapshot } from '../hooks/useFieldActorSnapshot';
import type { AppointmentTimeAllowedForPortalContext } from '../machines/appointmentTimeAllowedForPortal.machine';
import { useCommonTranslation } from '@/hooks/useCommonTranslation';

export function AppointmentTimeNotAllowedMessage({ index }: { index: number }) {
  const t = useCommonTranslation();
  const { fieldRefs } = useReservationFormMachines();
  const actor = fieldRefs.appointmentTimeAllowedForPortal;
  const snapshot = useFieldActorSnapshot(actor);
  const { isAllowedByIndex } = (snapshot?.context ?? {
    isAllowedByIndex: [],
  }) as AppointmentTimeAllowedForPortalContext;

  // `undefined` happens briefly when a new leg mounts before recomputing the
  // new count. Treat as allowed so the message doesn't flash on adding a trip leg.
  if (isAllowedByIndex[index] !== false) return null;

  return (
    <FormHelperText error>
      {`${t('reservation.appointmentTimeNotAllowedErrorMessage')} ${t('footer.phoneNumber')}`}
    </FormHelperText>
  );
}
